const initialState = {
    calendarData:[],
    
    // userAdded: {}
}

export const CalendarReducer = (state = initialState, action) => {
    switch (action.type) {

      
        default:
            return { ...state }
    }
}
